module.exports = __webpack_public_path__ + "static/media/Picture-perfect-Web-Dining-Experiences.b6a096e9.jpg";